import React, { useState } from "react";
import Box from "@mui/material/Box";
import {
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Typography,
    IconButton
} from "@mui/material";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SchoolIcon from '@mui/icons-material/School';
import InfoIcon from '@mui/icons-material/Info';
import MailIcon from '@mui/icons-material/Mail';
import { useAuth } from "../Auth/AuthPage.jsx";
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Home } from "@mui/icons-material";
import GroupsIcon from '@mui/icons-material/Groups';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ShopIcon from '@mui/icons-material/Shop';

const SiteMenu = ({ role }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const { loggedIn, user, logout, currentUserProfile } = useAuth();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        setAnchorEl(null);
        if (event === undefined) {
            return;
        }
        window.location = event.currentTarget.getAttribute("href");
    };

    return (
        <Box>
            <IconButton
                color="inherit"
                onClick={handleClick}
                aria-label="open menu"
                size="small"
            >
                <MenuIcon/>
            </IconButton>
            <Menu
                id={"main-menu"}
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose(undefined)}
            >
                <Box>
                {loggedIn && (
                    <Stack alignItems="center" justifyContent="center" sx={{ padding: 1 }} mb={5}>
                        <Box sx={{ display: 'flex', alignItems: 'center', padding: 1 }}>
                              <Avatar src={currentUserProfile?.pic?.formats?.thumbnail?.url} sx={{width: '60px', height: '60px' }} />
                        </Box>
                        <Box sx={{ padding: 1, textAlign: 'center', fontWeight: 'bold' }}>
                            {currentUserProfile?.name || user?.email}
                        </Box>
                        <Button sx={{
                            minWidth: '24px', // Reduce minimum width
                            padding: '1px 8px', // Adjust padding
                            fontSize: '0.75rem', // Reduce font size
                        }} color={"secondary"} variant={"contained"} onClick={()=>{
                            logout();
                            handleClose();
                            window.location = "/";
                        }}>Log out</Button>
                    </Stack>
                )}

                {loggedIn && user.calendarAdmin && (
                    <MenuItem onClick={handleClose} href={"/admin"}>
                        <ListItemIcon><AdminPanelSettingsIcon /></ListItemIcon>
                        <ListItemText>Admin</ListItemText>
                    </MenuItem>
                )}
                {loggedIn && user.calendarAdmin && <Divider />}
                {/*{loggedIn && <MenuItem onClick={handleClose} href={"/dancecard"}><ListItemIcon><NightlifeIcon /></ListItemIcon><ListItemText>Dance Card</ListItemText></MenuItem>}*/}
                {loggedIn && (
                    <>
                        <MenuItem onClick={handleClose} href={"/account"}>
                            <ListItemIcon><SettingsIcon /></ListItemIcon>
                            <ListItemText><Typography variant={"overline"}>Settings</Typography></ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleClose} href={"/account/events"}>
                            <ListItemIcon><AccountCircleIcon /></ListItemIcon>
                            <ListItemText><Typography variant={"overline"}>My Contributions</Typography></ListItemText>
                        </MenuItem>
                        <Divider />
                    </>
                )}
                <MenuItem onClick={handleClose} href={"/"}>
                    <ListItemIcon>
                        <Home fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>Home</Typography></ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose} href={"/where-to-dance/pro-calendar"}>
                    <ListItemIcon>
                        <CalendarMonthIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>Pro Calendar</Typography></ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose} href={"/where-to-dance"}>
                    <ListItemIcon>
                        <TravelExploreIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>WHERE TO DANCE</Typography></ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose} href={"/shopping"}>
                    <ListItemIcon>
                        <ShopIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>SHOP</Typography></ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose} href="/quick-start-austin-2-step-guide">
                    <ListItemIcon>
                        <MenuBookIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>Culture</Typography></ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose} href="/twostep-lessons">
                    <ListItemIcon>
                        <SchoolIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>Lessons</Typography></ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose} href="/community">
                    <ListItemIcon>
                        <GroupsIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>Community</Typography></ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose} href="/about">
                    <ListItemIcon>
                        <InfoIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>About</Typography></ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose} href="/contact">
                    <ListItemIcon>
                        <MailIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText><Typography variant={"overline"}>Contact</Typography></ListItemText>
                </MenuItem>
                </Box>
            </Menu>
        </Box>

    );
};

export default SiteMenu;
